import * as React from "react";
function formatTimer(inputSeconds) {
    var minutes = Math.floor(inputSeconds / 60);
    var seconds = inputSeconds - minutes * 60;
    var SINGLE_DIGIT_LIMIT = 10;
    if (minutes < SINGLE_DIGIT_LIMIT) {
        minutes = "0" + minutes;
    }
    if (seconds < SINGLE_DIGIT_LIMIT) {
        seconds = "0" + seconds;
    }
    return minutes + ":" + seconds;
}
export default function Timer() {
    var _a = React.useState(0), timerSeconds = _a[0], setTimerSeconds = _a[1];
    var timer = formatTimer(timerSeconds);
    React.useEffect(function () {
        var timerInterval = setInterval(function () { return setTimerSeconds(function (prev) { return prev + 1; }); }, 1000);
        return function () {
            clearInterval(timerInterval);
        };
    }, []);
    return React.createElement("div", { className: "self-center text-[22px] font-bold" }, timer);
}
